import { formatMoneyValue } from '@utils/moneyFormatting';
import { Typography, useTheme } from 'hephaestus/web';
import { round } from 'lodash-es';

const formatFraction = (fraction: number | undefined) =>
  !isFinite(fraction || 0)
    ? '100.00'
    : round((fraction || 0) * 100, 2).toFixed(2);

const SmallDollarPercentage = ({
  cents,
  percentage,
  secondaryPercentage,
  bold = false,
  showColor = false,
  showPercentage = true,
  isRedColor = false,
  className,
}: {
  cents: number;
  percentage?: number;
  /** Portfolio-wide target % (0–1), inline beside within-class % when shown. */
  secondaryPercentage?: number;
  bold?: boolean;
  showColor?: boolean;
  showPercentage?: boolean;
  isRedColor?: boolean;
  className?: string;
}) => {
  const value = formatMoneyValue(round(cents) || 0);
  const theme = useTheme();
  return (
    <Typography
      variant='labelSmall'
      sx={{ fontWeight: bold ? 800 : 400, fontVariantNumeric: 'tabular-nums' }}
      className={className}
      color={
        showColor && isRedColor
          ? theme.color.negative
          : showColor && percentage
            ? Math.abs(percentage) > 0.1
              ? theme.color.negative
              : showColor && Math.abs(percentage) > 0.05
                ? theme.color.warning
                : 'default'
            : 'default'
      }
    >
      {value}
      {showPercentage && (
        <>
          <br />
          {formatFraction(percentage)}%
          {secondaryPercentage != null && (
            <>
              {' · '}
              <Typography
                component='span'
                variant='labelSmall'
                color={bold ? 'inherit' : 'text.secondary'}
                sx={{
                  fontSize: 'inherit',
                  fontVariantNumeric: 'tabular-nums',
                  fontWeight: bold ? 800 : 400,
                }}
              >
                {formatFraction(secondaryPercentage)}%
              </Typography>
            </>
          )}
        </>
      )}
    </Typography>
  );
};

export default SmallDollarPercentage;
